import React from "react";
const BreakoutDecorator = {
  rule: () => true,
  decorate: ({ node, element, isRoot, context }) => {
    if (!isRoot) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, element);
    }
    const breakoutSettings = context.theme.breakout;
    if (!breakoutSettings) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, element);
    }
    const breakout = breakoutSettings.rule({ node });
    return /* @__PURE__ */ React.createElement("div", { ...{ "data-breakout": breakout } }, element);
  }
};
export {
  BreakoutDecorator
};
//# sourceMappingURL=breakoutDecorator.js.map
